import { TFilterState, FilterNameKey } from '@src/types/weddingHallFilter';
import './searchFilter.scss'
import { useEffect } from 'react';

// 상품탭 > 예식일 filter인 경우 중복되는 해(year) 삭제
const removeDuplicateYear = (value: string|null): string | null => {
  if (!value) return null;
  
  // 상세날짜를 선택한 것인지 정규식으로 확인
  const dateRangePattern = /\d{4}년 \d{2}월 \d{2}일~\d{4}년 \d{2}월 \d{2}일/; 
  if (dateRangePattern.test(value)){ 
    const [start, end] = value.split('~');
    if(start === end){
      return start
    }else{
      return value
    }
  };

  const monthsArray = value.split(',').map(item => item.trim());
  const groupedByYear: { [key: string]: string[] } = {};

  monthsArray.forEach((item) => {
    const match = item.match(/(\d{4}년)\s(\d{2}월)/);
    if (match) {
      const year = match[1];
      const month = match[2];
      if (!groupedByYear[year]) {
        groupedByYear[year] = [];
      }
      groupedByYear[year].push(month);
    }
  });

  return Object.entries(groupedByYear)
    .map(([year, months]) => `${year} ${months.join(', ')}`)
    .join(', ');
};


interface ISearchFilter {
	filter: TFilterState;
	onClick: () => void;
	currentFilterType: FilterNameKey | null;
}
const SearchFilter = ({filter, onClick, currentFilterType=null}: ISearchFilter) => {
  const filterString =   filter.typeName === 'WEDDING_DATE' ? removeDuplicateYear(filter.value) : filter.value

  return ( 
		<div 
			className={`product-filter badge badge-gray-line ${!!filter.value ? 'selected' :''}`}
			onClick={onClick}
		>
			<span>{filterString || filter.name}</span>
			{currentFilterType === filter.typeName ? 
				<i className={`icon ${!!filter.value ? 'icon-chevron-up-brown500-small': 'icon-chevron-up-gray500-small'}`}/> 
				:
				<i className={`icon ${!!filter.value ? 'icon-chevron-down-brown500-small': 'icon-chevron-down-gray500-small'}`}/>
			}
		</div>
	);
};

export default SearchFilter;